/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.Crocodile = function (scene) {
  this.scene = scene;
  this.x = 950;
  this.y = 560;
  this.crocodile = null;
};

EDC.Animations.Crocodile.prototype.create = function () {
  this.crocodile = this.scene.add.sprite(this.x, this.y, 'alligator');
};

EDC.Animations.Crocodile.prototype.fallDown = function () {
  this.scene.tweens.add({
    targets: this.crocodile,
    angle: 90,
    duration: 450,
    ease: 'Linear',
  });
  this.scene.tweens.add({
    targets: this.crocodile,
    y: 1500,
    duration: 800,
    ease: 'Linear',
  });
};

EDC.Animations.Crocodile.prototype.backToLog = function () {
  this.crocodile.setAngle(0);
  this.crocodile.setPosition(this.x, this.y);
};

export default EDC.Animations.Crocodile;
